import {
  ExclamationTriangleIcon,
  InformationCircleIcon,
  ShieldExclamationIcon,
} from "@heroicons/react/24/outline"
import { FC } from "react"

type RecommendationType = "info" | "positive" | "warning" | "negative"
interface RecommendationProps {
  title: string
  description: string
  type: RecommendationType
}

export const Recommendation: FC<RecommendationProps> = ({ title, description, type }) => {
  const renderIcon = (type: RecommendationType) => {
    switch (type) {
      case "info":
        return (
          <div className="rounded-full bg-sky-50 p-1.5">
            <InformationCircleIcon className="h-6 w-6 stroke-2 text-sky-600" aria-hidden="true" />
          </div>
        )
      case "positive":
        return (
          <div className="rounded-full bg-green-100/70 p-1.5">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
            >
              <path
                d="M14.0003 11H13.0003V9.99997C13.0003 9.73475 12.8949 9.4804 12.7074 9.29286C12.5198 9.10533 12.2655 8.99997 12.0003 8.99997C11.7351 8.99997 11.4807 9.10533 11.2932 9.29286C11.1056 9.4804 11.0003 9.73475 11.0003 9.99997V11H10.0003C9.73506 11 9.4807 11.1053 9.29317 11.2929C9.10563 11.4804 9.00028 11.7348 9.00028 12C9.00028 12.2652 9.10563 12.5195 9.29317 12.7071C9.4807 12.8946 9.73506 13 10.0003 13H11.0003V14C11.0003 14.2652 11.1056 14.5195 11.2932 14.7071C11.4807 14.8946 11.7351 15 12.0003 15C12.2655 15 12.5198 14.8946 12.7074 14.7071C12.8949 14.5195 13.0003 14.2652 13.0003 14V13H14.0003C14.2655 13 14.5198 12.8946 14.7074 12.7071C14.8949 12.5195 15.0003 12.2652 15.0003 12C15.0003 11.7348 14.8949 11.4804 14.7074 11.2929C14.5198 11.1053 14.2655 11 14.0003 11ZM20.1603 4.99997C19.094 3.94467 17.6856 3.30524 16.1893 3.19705C14.693 3.08886 13.2073 3.51904 12.0003 4.40997C10.7279 3.46361 9.14427 3.03448 7.5682 3.20901C5.99212 3.38353 4.54072 4.14875 3.50625 5.35055C2.47178 6.55236 1.9311 8.10149 1.99308 9.68598C2.05506 11.2705 2.71509 12.7726 3.84028 13.89L9.84028 19.94C10.4028 20.5018 11.1653 20.8173 11.9603 20.8173C12.7553 20.8173 13.5178 20.5018 14.0803 19.94L20.0803 13.89C20.6712 13.3126 21.1422 12.6242 21.4662 11.8642C21.7902 11.1042 21.9609 10.2877 21.9683 9.4616C21.9757 8.63548 21.8198 7.81603 21.5095 7.05035C21.1993 6.28467 20.7407 5.58786 20.1603 4.99997V4.99997ZM18.7503 12.46L12.7503 18.46C12.6573 18.5537 12.5467 18.6281 12.4249 18.6789C12.303 18.7296 12.1723 18.7558 12.0403 18.7558C11.9083 18.7558 11.7776 18.7296 11.6557 18.6789C11.5338 18.6281 11.4232 18.5537 11.3303 18.46L5.33028 12.46C4.54603 11.6583 4.10689 10.5814 4.10689 9.45997C4.10689 8.3385 4.54603 7.26162 5.33028 6.45997C6.12943 5.67096 7.20725 5.22854 8.33028 5.22854C9.4533 5.22854 10.5311 5.67096 11.3303 6.45997C11.4232 6.5537 11.5338 6.62809 11.6557 6.67886C11.7776 6.72963 11.9083 6.75577 12.0403 6.75577C12.1723 6.75577 12.303 6.72963 12.4249 6.67886C12.5467 6.62809 12.6573 6.5537 12.7503 6.45997C13.5494 5.67096 14.6272 5.22854 15.7503 5.22854C16.8733 5.22854 17.9511 5.67096 18.7503 6.45997C19.5405 7.26252 19.9835 8.34365 19.9835 9.46997C19.9835 10.5963 19.5405 11.6774 18.7503 12.48V12.46Z"
                fill="#16A34A"
              />
            </svg>
          </div>
        )
      case "negative":
        return (
          <div className="rounded-full bg-red-50 p-1.5">
            <ShieldExclamationIcon className="h-6 w-6 stroke-2 text-red-600" aria-hidden="true" />
          </div>
        )
      case "warning":
        return (
          <div className="rounded-full bg-yellow-50 p-1.5">
            <ExclamationTriangleIcon className="h-6 w-6 stroke-2 text-yellow-600" aria-hidden="true" />
          </div>
        )
    }
  }
  return (
    <div className="flex flex-row items-start gap-3">
      <div>{renderIcon(type)}</div>
      <div className="flex flex-col">
        <div className="text-base font-medium text-gray-900">{title}</div>
        <p className="mt-1 text-sm leading-normal text-gray-500">{description}</p>
      </div>
    </div>
  )
}
